import SettingsEventTriggers from './SettingsEventTriggers'

export default SettingsEventTriggers
